import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PHBHPFeaturePackageConfigurationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-configuration/lib/ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../app.config';
import { Ward } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/Models/Ward';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { runInThisContext } from 'vm';
import { PHBHPFeaturePackageObserveObservationService } from '../ObserveObservation/ph-bhp-feature-package-observe-observation.service';
import { Subscription, forkJoin } from 'rxjs';

@Component({
  selector: 'app-import-stations',
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow-y]': '"hidden"'
  },
  templateUrl: './import-stations.component.html',
  styleUrls: ['./import-stations.component.css']
})
export class ImportStationsComponent implements OnInit {

  constructor(private modalService: BsModalService, public modalRef: BsModalRef, public layoutService: PHBHPLayoutPackageService, public translate: TranslateService, public config: AppConfig, private router: Router, public observationService: PHBHPFeaturePackageObserveObservationService) {
  }

  subscription: Subscription;
  unSubscription: Subscription;
  pageInfo;
  userData: any;
  institutionID: any;
  institutionData: any;
  institutions: any;
  isgroup: boolean = false;
  service;
  data;
  mapMigratedWards;
  wards: any[];
  webkessWards: any;
  wardsToMap: any[];
  departments: any;
  departmentTypes: any;
  matchRef: BsModalRef;
  @ViewChild('matchDuplicated') matchDuplicated: TemplateRef<any>;

  translationKeys: typeof TranslationKeys = TranslationKeys;
  departmentsSelected: number = 0;

  @ViewChild('gridValues') gridValues;
  groupInstitutionlist = [];
  wardModelGridEdit: any = new UntypedFormGroup({
    wardName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(50)])),
    departmentID: new UntypedFormControl('')
  });
  dataFromWebKess: any;
  // constructor(private service: PHBHPFeaturePackageConfigurationService, private data: PHBHPLayoutPackageService,private modalService: BsModalService,public translate: TranslateService, public config: AppConfig, private router: Router) { 

  // }
  location: Location;
  gridData: any = {
    webkessWards: [],
    wards: [],
    departments: []
  };

  importActions = [
    { action: 'ignore', actionName:'WEBKESS_INTEGRATION.ACTIONS.IGNORE', actionId:0},
    { action: 'import', actionName:'WEBKESS_INTEGRATION.ACTIONS.IMPORT', actionId:1},
    { action: 'match', actionName:'WEBKESS_INTEGRATION.ACTIONS.MATCH', actionId:2}
  ];
  actionData: [] = [];
  defaultAction = 0;
  
  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID;
      this.loadGrid();
      this.userData = this.config.userData;
    }

    this.getInstitutionDetails();
    this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getInstitutionDetails();
    })

    
    this.pageInfo = {
      ofLabel: this.translationKeys.Dashboard.GeneralOf,
      items: this.translationKeys.Configure.Wards,
      itemsPerPageLabel: this.translationKeys.Configure.PerPage
    };

  }

  ngOnDestroy() {

  }

  getInstitutionDetails() {
    this.service.GetInstitutionDetails(this.institutionID).subscribe((res: any) => {
      this.institutionData = res;
      if (this.institutionData.groupInstitutions == null) {
        this.isgroup = true;
      }
      else {
        this.isgroup = false;
      }
      if (this.institutionData.groupInstitutions) {
        this.institutionData.groupInstitutions.forEach((value, index) => {
          if (value.institution.isGroup == false) {
            this.groupInstitutionlist.push(value.institution.institutionName)
          }
        })
      }

    });

  }

  getDepartmentTypeList() {
    return this.service.getApi('Departments/GetDepartmentTypes', true);
  }

  loadGrid(){
    this.layoutService.showLoader = true;

    const departmensObs = this.service.getDepartmentList();
    const webkessWardsObs = this.service.getWebKessWardsByInsId(this.institutionID);
    const departmentTypesObs = this.service.getDepartmentTypeList();
    forkJoin([departmensObs, webkessWardsObs, departmentTypesObs]).subscribe(([departmensRes,webkessWardsRes,departmentTypesRes]:[any,any,any]) => {
      this.departments = departmensRes;
      this.departmentTypes = departmentTypesRes;
      this.departments.forEach(dept => {
        dept.departmentName = this.layoutService.translateText(dept.departmentName);
      });
      this.departments.sort((a, b) => a.departmentName.localeCompare(b.departmentName));
      for (const webkessWard of this.gridData.webkessWards) {
        webkessWard.actionId = 0; // init selected action
      }
      this.gridData.webkessWards = webkessWardsRes.filter(el => !this.wards.some(w => el.oeName === w.webkessWardName));
      this.gridData.wards = [{wardName: this.layoutService.translateText(this.translationKeys.Webkess.WebkessSelectWard), wardID: -1}].concat(this.wards.filter(w => w.webkessWardName == null && !w.iswebKessStation && w.isActive));
      this.gridData.departments = [{departmentID:-1, departmentName: this.layoutService.translateText(this.translationKeys.Webkess.WebkessSelectDepartment)}].concat(this.departments);
      this.gridData.departmentTypes = [{departmentTypeID: -1, departmentTypeName: this.layoutService.translateText('CONFIGURE.SELECT_DEPARTMENT_TYPE')}].concat(this.departmentTypes);
      this.layoutService.showLoader = false;
    });


  }

  onActionChange(event, index) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.gridData.webkessWards[index].actionId = selectedValue;
    delete this.gridData.webkessWards[index].webkessWardName;
    delete this.gridData.webkessWards[index].mappedWardId;
    delete this.gridData.webkessWards[index].departmentID;
    delete this.gridData.webkessWards[index].wardName;
    
  }

  onDeptChange(event, index){
    delete this.gridData.webkessWards[index].webkessWardName;
    delete this.gridData.webkessWards[index].mappedWardId;
    this.gridData.webkessWards[index].departmentID = event.target.value;
    this.gridData.webkessWards[index].wardName = this.gridData.webkessWards[index].oeName;
  }

  onWardChange(event, index){
    delete this.gridData.webkessWards[index].departmentID;
    delete this.gridData.webkessWards[index].wardName;
    this.gridData.webkessWards[index].webkessWardName = this.gridData.webkessWards[index].oeName;
    this.gridData.webkessWards[index].mappedWardId = event.target.value;
  }

  onDepartmentTypeIDChange(event, index) {
    delete this.gridData.webkessWards[index].departmentTypeID;
    delete this.gridData.webkessWards[index].departmentTypeName;
    this.gridData.webkessWards[index].departmentTypeID = event.target.value;
    this.gridData.webkessWards[index].departmentTypeName = this.departmentTypes.find(dt => dt.departmentTypeID == event.target.value).departmentTypeName;
  }

  onClickClose() {
    this.modalRef.hide();
    this.layoutService.importStationsClicked = false;
  }

  onSubmit(event) {
    event.preventDefault();
    this.layoutService.showLoader = true;

    let wardsToUpdate = this.gridData.webkessWards.filter(w => w.actionId == 1 || w.actionId == 2);
    if(wardsToUpdate.length == 0){
      this.layoutService.showWarning(this.layoutService.translateText(this.translationKeys.Webkess.WebkessNoWardsToUpdate));
      this.layoutService.showLoader = false;
      return
    }

    wardsToUpdate.map(ward => {
      ward.webkessWardName = ward.oeName;
    })

    let checkParameters = false;
    wardsToUpdate.forEach(webkessWard => {
      if(webkessWard.actionId == 1){
        if(!webkessWard.departmentID || webkessWard.departmentID == -1){
          checkParameters = true;
        }
        if (!webkessWard.departmentTypeID || webkessWard.departmentTypeID == -1) {
          checkParameters = true;
        }
      }else{
        if(!webkessWard.mappedWardId || webkessWard.mappedWardId == -1){
          checkParameters = true;
        }
      }
    });

    if(checkParameters){
      this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.WebkessCheckParameters));
      this.layoutService.showLoader = false;
      return;
    }

    if(this.hasDuplicateWebkessWardName(wardsToUpdate)){
      this.layoutService.showError(this.layoutService.translateText(this.translationKeys.Webkess.WebkessDuplicateWards));
      this.layoutService.showLoader = false;
      return;
    }
    
    // assign institutionId to new imported wards
    wardsToUpdate.map(ward => {
      ward.institutionID = this.institutionID;
    });

    this.service.updatewebKessWards(this.userData.userId, wardsToUpdate).subscribe(
      (res: any) => { }, (err) => { }, () => {
        this.layoutService.importStationsClicked = false;
        // this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.Webkess.DownloadedWards));
        this.router.navigateByUrl('/configure/wards');
        this.layoutService.showLoader = false;
        this.modalRef.hide();
        // if(this.mapMigratedWards){
        //   this.observationService.updateObservationsOfMappedWards(wardsToUpdate).subscribe(res=>{
            
        //   })
        // }
      })
    
  }

  hasDuplicateWebkessWardName(array) {
    const nameMap = {};
    for (const item of array) {
      if(item.actionId == '2'){
        if (item.mappedWardId in nameMap) {
          return true;
        }else
        nameMap[item.mappedWardId] = true;
      }
    }
      return false;
  }

}